<template>
  <AuthLayout>
    <div class="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-5">
            <div class="card">
              <div class="card-body px-3 py-5">
                <div class="mx-auto mb-4 text-center auth-logo">
                  <a class="logo-dark" href="javascript:void(0);">
                    <img alt="logo dark" height="32" src="@/assets/images/logo-dark.png" />
                  </a>
                  <a class="logo-light" href="javascript:void(0);">
                    <img alt="logo light" height="28" src="@/assets/images/logo-light.png" />
                  </a>
                </div>
                <h2 class="fw-bold text-uppercase text-center fs-18">
                  ورود
                </h2>
                <p class="text-muted text-center mt-1 mb-4">
                  برای دسترسی به پنل مدیریت، آدرس ایمیل و رمز عبور خود را وارد کنید.
                </p>
                <div class="px-4">
                  <form @submit.prevent="handleSubmit" class="authentication-form">
                    <!-- Error Message -->
                    <div v-if="errorMessage" class="alert alert-danger" role="alert">
                      {{ errorMessage }}
                    </div>
                    
                    <!-- Loading State -->
                    <div v-if="isLoading" class="text-center mb-3">
                      <div class="spinner-border text-danger" role="status">
                        <span class="visually-hidden">در حال بارگذاری...</span>
                      </div>
                    </div>

                    <div class="mb-3">
                      <label class="form-label" for="phone_number">
                        شماره همراه
                      </label>
                      <input
                        v-model="formData.phone_number"
                        class="form-control bg-light bg-opacity-50 border-light py-2"
                        id="phone_number"
                        name="phone_number"
                        placeholder="09121212121"
                        type="tel"
                        pattern="09\d{9}"
                        maxlength="11"
                        required
                        :disabled="isLoading"
                      />
                    </div>
                    <div class="mb-3">
                      <a class="float-end text-muted text-unline-dashed ms-1" href="javascript:void(0);">
                        تغییر رمزعبور
                      </a>
                      <label class="form-label" for="password">
                        رمزعبور
                      </label>
                      <input
                        v-model="formData.password"
                        class="form-control bg-light bg-opacity-50 border-light py-2"
                        id="password"
                        placeholder="رمزعبور را وارد کنید"
                        type="password"
                        required
                        :disabled="isLoading"
                      />
                    </div>
                    <div class="mb-3">
                      <div class="form-check">
                        <input
                          v-model="formData.remember"
                          class="form-check-input"
                          id="checkbox-signin"
                          type="checkbox"
                          :disabled="isLoading"
                        />
                        <label class="form-check-label" for="checkbox-signin">
                          من را به یاد داشته باش
                        </label>
                      </div>
                    </div>
                    <div class="mb-1 text-center d-grid">
                      <button
                        class="btn btn-danger py-2 fw-medium"
                        type="submit"
                        :disabled="isLoading"
                      >
                        {{ isLoading ? 'در حال ورود...' : 'ورود' }}
                      </button>
                    </div>
                  </form>
                  <p class="mt-3 fw-semibold no-span">
                    یا ثبت نام کن با
                  </p>
                  <div class="text-center">
                    <a class="btn btn-outline-light shadow-none" href="javascript:void(0);">
                      <IconifyIcon icon="bx:bxl-google" class="fs-20" />
                    </a>
                    <a class="btn btn-outline-light shadow-none" href="javascript:void(0);">
                      <IconifyIcon icon="ri:facebook-fill" class="fs-20" />
                    </a>
                    <a class="btn btn-outline-light shadow-none" href="javascript:void(0);">
                      <IconifyIcon icon="bx:bxl-github" class="fs-20" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <p class="mb-0 text-center text-white">
              جدید هستید؟
              <router-link class="text-reset text-unline-dashed fw-bold ms-1" to="/signup">
                ثبت نام
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </AuthLayout>
</template>

<script>
import { ref, reactive } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { signIn } from '@/api/management/auth'
import AuthLayout from '@/management/layout/AuthLayout.vue'

export default {
  name: 'SignIn',
  components: {
    AuthLayout
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const isLoading = ref(false)
    const errorMessage = ref('')
    
    const formData = reactive({
      phone_number: '',
      password: '',
      remember: false
    })

    const handleSubmit = async () => {
      errorMessage.value = ''
      isLoading.value = true

      try {
        await signIn({
          phone_number: formData.phone_number,
          password: formData.password
        })

        // If remember me is checked, we could store additional info
        // The token is already stored by the signIn function

        // Redirect to dashboard or the originally requested page
        const redirectPath = route.query.redirect || '/dashboard'
        router.push(redirectPath)
      } catch (error) {
        // Handle error
        if (error.message) {
          errorMessage.value = error.message
        } else if (error.errors) {
          // Laravel validation errors
          const firstError = Object.values(error.errors)[0]
          errorMessage.value = Array.isArray(firstError) ? firstError[0] : firstError
        } else {
          errorMessage.value = 'خطا در ورود به سیستم. لطفاً دوباره تلاش کنید.'
        }
      } finally {
        isLoading.value = false
      }
    }

    return {
      formData,
      isLoading,
      errorMessage,
      handleSubmit
    }
  }
}
</script>

<style scoped>
.text-white {
  color: #fff !important;
}

.text-unline-dashed {
  text-decoration: underline;
  text-decoration-style: dashed;
}

.spinner-border {
  width: 2rem;
  height: 2rem;
}
</style>

